import { useQuery } from '@tanstack/react-query';
import { SalesMetrosService } from '../services';
import { salesMetrosKeys } from '../queryKeys';
import { isZipSearch } from '../salesMetroRows';

/**
 * The metro owning `zip`, or `null` — asked only for a whole 5-digit zip,
 * since organization-service 422s anything else.
 *
 * @param {string} zip
 */
export const useSalesMetroByZip = (zip) => {
  const isZip = isZipSearch(zip);

  const { data, isError, isFetching } = useQuery({
    queryKey: salesMetrosKeys.byZip(zip),
    queryFn: () => SalesMetrosService.findSalesMetroByZip(zip),
    enabled: isZip,
    retry: false,
  });

  return {
    metro: isZip ? data ?? null : null,
    isFetching,
    isError,
  };
};
